import React, { Component } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ButtonGroup,
} from "reactstrap";
// import './summary-styles.css';
import Header from "../HeaderComponent/Header";
import * as Constdata from "../../Constants/ApiConstants";
import SerraLoader from "../CommonComponent/Loader";
import ColorComponent from "./SvgColorOverview";
import ResingBenefitTextComponent from "./ResingBenefitTextComponent";
import * as message from "../../Constants/MessageConstant";
import SummaryStatus from "../AnalysisComponent/RecommendationSummary";
import ValidationSummary from "../AnalysisComponent/ValidationSummary";
import SerraError from "../CommonComponent/Error";
import OnDemandMetrics from "../PPUComponent/OnDemandMetrics";
import ReactGA from "react-ga4";
import jstz from "jstz";
import { getStringDate } from "../../Constants/CommonConstant";
import EntityTypeSummary from "../PdfComponent/reportPdf/EntityTypeSummary";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { analysisReport, fetchFont } from "../PdfComponent/PdfFunctions";
import ProviderUtils from "../CommonComponent/ProviderUtils";
import { setDataSourceRefreshStatus } from "../../reducers/dataSourcePayloadSlice";
import { resetRefreshTimer } from "../../reducers/datasSourceRefreshListener";
import { FaSearchPlus } from "react-icons/fa";
class Summary extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.showOverview = this.showOverview.bind(this);
    this.toggleOnDemand = this.toggleOnDemand.bind(this);
    this.handleClientSidePDF = this.handleClientSidePDF.bind(this);
    this.handleRecommendationPreferenceRequest =
      this.handleRecommendationPreferenceRequest.bind(this);

    this.state = {
      providerName: "",
      loggedInUser: "",
      currentDateTime: 0,
      analysisStatus:
        this.props.location.state === undefined
          ? ""
          : this.props.location.state.data,
      viewResultData:
        this.props.location.state === undefined
          ? ""
          : this.props.location.state.oldData,
      modalLoader: false,
      resultData: [],
      aggIconData: [],
      balIconData: [],
      healthyIconData: [],
      gaiIconData: [],
      atb: "1",
      acol: "",
      acsubcol: "",
      modal: false,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: true,
      previousView:
        this.props.location.state === undefined
          ? ""
          : this.props.location.state.lastView,
      isFreeTrial: false,
      isRedirect: true,
      modalOnDemand: false,
      landOn:
        this.props.location.state !== undefined &&
        this.props.location.state.landOn !== undefined
          ? this.props.location.state.landOn
          : null,
      isClientSidePDF: false,
      enhancedCostRatio: 0,
      economicalPerfRatio: 0,
    };
  }

  componentDidMount() {
    // ReactGA.initialize(message.MeasurementId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: window.location.pathname,
    //   title: "Analysis Summary",
    // });
    this.props.registerListners(true);
    this.getInitialData();
  }

  getInitialData = (loader = true) => {
    const basicVmId = this.state.analysisStatus.basicvmid;
    const analysiSeqNum = this.state.analysisStatus.analysisseqnum;
    this.setState({ modalLoader: loader });
    fetch(
      `${Constdata.ANALYSIS_OVERVIEW_URL}/${basicVmId}/${analysiSeqNum}/current`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    )
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.success === true) {
          let multipleRecommentions = responseJson;
          this.handleRecommendationPreferenceRequest(
            responseJson.orgInfo.providerName,
            responseJson.orgInfo.orgId
          );

          window.scrollTo(0, 0);
          this.setState({
            resultData: responseJson.data,
            isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
            providerName: responseJson.orgInfo.providerName,
            currentDateTime: responseJson.orgInfo.currentDateTime,
            loggedInUser: responseJson.orgInfo.loggedInUser,
            orgId: responseJson.orgInfo.orgId,
          });
          this.setState((prevState) => ({
            analysisStatus: {
              ...prevState.analysisStatus,
              status_change_datetime: responseJson.data.status_change_datetime,
            },
          }));
          var aggrIcondata = [];
          var balIcondata = [];
          var healthyIcondata = [];
          var gaiIcondata = [];
          var gaicpu = [];
          var gainetwork = [];
          var gaimemory = [];
          var gaidisks = [];

          const analysisGoalTypes = [
            { label: "Economical", key: "aggressive" },
            { label: "Balanced", key: "balanced" },
            { label: "Enhanced", key: "conservative" },
          ];

          for (const analysisType of analysisGoalTypes) {
            const analysisIconData =
              multipleRecommentions.data[analysisType.key];
            const groupedIconData = [];
            // const choiceObjNew = { recommendationChoiceNum: "" };

            analysisIconData.vm.forEach((key) => {
              const choice = key.recommendationChoiceNum ?? 0;

              if (!groupedIconData[choice]) {
                groupedIconData[choice] = {
                  recommendationChoiceNum: choice,
                  cpu: [],
                  memory: [],
                  network: [],
                  disks: [],
                  gpu: [],
                  gpumemory: [],
                };
                // Indexed by choice only. A push here also appended the same object at the
                // next index, so choice 1 merged into choice 0 (double disks/icons).
              }
            });

            analysisIconData.vm.forEach((key) => {
              const choice = key.recommendationChoiceNum ?? 0;

              groupedIconData[choice].cpu.push({
                costColor: key.current_vcpu_cost,
                healthColor: key.current_vcpu_health,
                icon: "cpu",
                resize: key.vcpuResizeImage,
                status: key.recommendedVMStatus,
                recommendationsIconColor: {
                  costColor: key.recommended_cpu_util,
                  healthColor: key.recommended_cpu_health,
                },
              });
              groupedIconData[choice].memory.push({
                costColor: key.current_memory_cost,
                healthColor: key.current_memory_health,
                icon: "memory",
                resize: key.memoryResizeImage,
                status: key.recommendedVMStatus,
                recommendationsIconColor: {
                  costColor: key.recommended_mem_util,
                  healthColor: key.recommended_mem_health,
                },
              });
              groupedIconData[choice].network.push({
                costColor: key.current_network_cost,
                healthColor: key.current_network_health,
                icon: "network",
                resize: key.networkResizeImage,
                status: key.recommendedVMStatus,
                recommendationsIconColor: {
                  costColor: key.recommended_net_util,
                  healthColor: key.recommended_net_health,
                },
              });
            });

            analysisIconData.osdisk.forEach((key) => {
              const choice = key.recommendationChoiceNum ?? 0;

              groupedIconData[choice].disks.push({
                costColor: key.current_os_disk_cost,
                healthColor: key.current_os_disk_health,
                icon: "osdisk",
                resize: key.osDiskResizeImage,
                status: key.recommendedOSDiskStatus,
                recommendationsIconColor: {
                  costColor: key.recommended_osdisk_util,
                  healthColor: key.recommended_osdisk_health,
                },
              });
            });

            Object.keys(analysisIconData.dataDisk || {}).length > 0 &&
              Object.keys(analysisIconData.dataDisk).forEach((key) => {
                analysisIconData.dataDisk[key].forEach((value) => {
                  const choice = value.recommendationChoiceNum ?? 0;

                  groupedIconData[choice].disks.push({
                    costColor: value.current_data_disk_cost,
                    healthColor: value.current_data_disk_health,
                    icon: "datadisk",
                    resize: value.diskResizeImage,
                    status: value.recommendedDataDiskStatus,
                    recommendationsIconColor: {
                      costColor: value.recommended_datadisk_util,
                      healthColor: value.recommended_datadisk_health,
                    },
                  });
                });
              });

            analysisIconData.gpuDTO.forEach((key) => {
              const choice = key.recommendationChoiceNum ?? 0;

              if (key.currentGpuNum) {
                groupedIconData[choice].gpu.push({
                  costColor: key.gpuUtilization_cost,
                  healthColor: key.gpu_sm_health,
                  icon: "gpu",
                  resize: "",
                  status: null,
                  recommendationsIconColor: {
                    costColor: key.recommended_gpuproc_util,
                    healthColor: key.recommended_gpuproc_health,
                  },
                });

                groupedIconData[choice].gpumemory.push({
                  costColor: key.gpuMemUsed_cost,
                  healthColor: key.gpu_mem_health,
                  icon: "gpumemory",
                  resize: "",
                  status: null,
                  recommendationsIconColor: {
                    costColor: key.recommended_gpumem_util,
                    healthColor: key.recommended_gpumem_health,
                  },
                });
              }
            });

            if (analysisType.label === "Economical") {
              aggrIcondata = groupedIconData;
              this.setState({ aggIconData: aggrIcondata });
            }

            if (analysisType.label === "Balanced") {
              balIcondata = groupedIconData;
              this.setState({ balIconData: balIcondata });
            }

            if (analysisType.label === "Enhanced") {
              healthyIcondata = groupedIconData;
              this.setState({ healthyIconData: healthyIcondata });
            }
          }
          multipleRecommentions.data.gaiValidationData &&
            multipleRecommentions.data.gaiValidationData.vm.forEach((key) => {
              gaicpu.push({
                costColor: key.current_vcpu_cost,
                healthColor: key.current_vcpu_health,
                icon: "cpu",
                resize: key.vcpuResizeImage,
                status: key.recommendedVMStatus,
              });
              gaimemory.push({
                costColor: key.current_memory_cost,
                healthColor: key.current_memory_health,
                icon: "memory",
                resize: key.memoryResizeImage,
                status: key.recommendedVMStatus,
              });
              gainetwork.push({
                costColor: key.current_network_cost,
                healthColor: key.current_network_health,
                icon: "network",
                resize: key.networkResizeImage,
                status: key.recommendedVMStatus,
              });
            });
          multipleRecommentions.data.gaiValidationData &&
            multipleRecommentions.data.gaiValidationData.osdisk.forEach(
              (key) => {
                gaidisks.push({
                  costColor: key.current_os_disk_cost,
                  healthColor: key.current_os_disk_health,
                  icon: "osdisk",
                  resize: key.osDiskResizeImage,
                  status: key.recommendedOSDiskStatus,
                });
              }
            );
          multipleRecommentions.data.gaiValidationData &&
            Object.keys(
              multipleRecommentions.data.gaiValidationData.dataDisk
            ).map((key) => {
              return multipleRecommentions.data.gaiValidationData.dataDisk[
                key
              ].map((value) => {
                gaidisks.push({
                  costColor: value.current_data_disk_cost,
                  healthColor: value.current_data_disk_health,
                  icon: "datadisk",
                  resize: value.diskResizeImage,
                  status: value.recommendedDataDiskStatus,
                });
              });
            });
          gaiIcondata.push({
            cpu: gaicpu,
            memory: gaimemory,
            network: gainetwork,
            disks: gaidisks,
          });
          this.setState({ gaiIconData: gaiIcondata });

          this.setState({ modalLoader: false });
          var ele = null;
          if (this.state.landOn !== null) {
            ele = document.getElementById(this.state.landOn);
          }
          if (ele !== null) {
            var offset = ele.offsetTop;
            let adj = this.state.landOn === "analysis" ? 66 : 218;

            window.scrollTo(0, offset - adj);
          } else {
            window.scrollTo(0, 0);
          }
          var pgAc = document.getElementById("pageRef");
          if (pgAc !== undefined && pgAc !== null) {
            let platform =
              responseJson.data !== undefined &&
              responseJson.data.metricsPlatform === "Host"
                ? " (Only Host Metrics Used)"
                : "";
            var header = `<div id="dashHeight">
                            <div style="display: flex; text-align: center; font-size: ${
                              window.innerWidth < 767 ? "16px;" : "22px;"
                            } color:#610058;">Rightsizing Summary of ${
              this.state.analysisStatus.vmname + platform
            }</div>
                            <div style="text-align: center; font-size: 15px; color: #610058;">${getStringDate(
                              this.state.currentDateTime
                            )} </div>
                        </div>`;
            document.getElementById("pageRef").innerHTML = header;
            pgAc.disabled = true;
          }
        } else if (responseJson.success === false) {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: responseJson.message,
            isErrorHeader: false,
            isRedirect: false,
          });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
        console.error(error);
      });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isRefreshDSAPI !== this.props.isRefreshDSAPI) {
      if (!this.props.isRefreshDSAPI) {
        this.getInitialData(false);
      }
    }
    if (
      prevProps.isRefreshing !== this.props.isRefreshing &&
      this.props.datasourceRefreshStatus === "success"
    ) {
      this.getInitialData(false);
    }
  }

  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.processLogut();
      this.props.history.push("/");
    }
  };
  showOverview = async (atTb, atCl, atSubCol) => {
    await this.setState({ atb: atTb, acol: atCl, acsubcol: atSubCol });

    this.props.history.push({
      pathname: "/overview",
      state: {
        loggedInUser: this.state.loggedInUser,
        data: this.state.resultData,
        analysisStatus: this.state.analysisStatus,
        viewResultData: this.state.viewResultData,
        aggrIconData: this.state.aggIconData,
        balIconData: this.state.balIconData,
        healthyIconData: this.state.healthyIconData,
        actTb: this.state.atb,
        actCl: this.state.acol,
        atSubCl: this.state.acsubcol,
        aggBenefitData: this.state.aggBenefitData,
        balBenefitData: this.state.balBenefitData,
        healthyBenefitData: this.state.healthyBenefitData,
        lastView: this.state.previousView,
        Listkey: this.props.location.state.key,
        isFreeTrial: this.state.isFreeTrial,
        providerName: this.state.providerName,
        currentDateTime: this.state.currentDateTime,
        gaiIconData: this.state.gaiIconData,
        enhancedCostRatio: this.state.enhancedCostRatio,
        economicalPerfRatio: this.state.economicalPerfRatio,
      },
    });
  };
  handleClose = () => {
    this.props.history.push({
      pathname: this.state.previousView,
      state: {
        data: this.state.viewResultData,
        UserAccount: this.props.location.state.key,
        isGoBack: true,
      },
    });
    this.setState({ modalLoader: false });
  };

  handleClientSidePDF = async () => {
    try {
      this.setState({ isClientSidePDF: true, modalLoader: true });

      const doc = new jsPDF();

      const lightFontUrl = require(`../../font/Poppins/Poppins-Light.ttf`);
      const regularFontUrl = require(`../../font/Poppins/Poppins-Regular.ttf`);
      const mediumFontUrl = require(`../../font/Poppins/Poppins-SemiBold.ttf`);
      const boldFontUrl = require(`../../font/Poppins/Poppins-Bold.ttf`);

      const [lightFont, regularFont, mediumFont, boldFont] = await Promise.all([
        fetchFont(lightFontUrl),
        fetchFont(regularFontUrl),
        fetchFont(mediumFontUrl),
        fetchFont(boldFontUrl),
      ]);

      doc.addFileToVFS("Poppins-Light.ttf", lightFont);
      doc.addFileToVFS("Poppins-Regular.ttf", regularFont);
      doc.addFileToVFS("Poppins-Medium.ttf", mediumFont);
      doc.addFileToVFS("Poppins-Bold.ttf", boldFont);

      // Add the fonts to jsdoc
      doc.addFont("Poppins-Light.ttf", "Poppins", "light");
      doc.addFont("Poppins-Regular.ttf", "Poppins", "normal");
      doc.addFont("Poppins-Medium.ttf", "Poppins", "medium");
      doc.addFont("Poppins-Bold.ttf", "Poppins", "bold");

      let pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
      let cnt = 1;
      try {
        const lastPage = await analysisReport(
          doc,
          this.state.resultData,
          this.props,
          this.state,
          pageNumber,
          cnt,
          this.state.economicalPerfRatio,
          this.state.enhancedCostRatio
        );
        pageNumber = lastPage;
      } catch (error) {
        console.error("Error in processing analysis report:", error);
      }
      // Generate PDF

      doc.save(`Console_${this.state.resultData.name}.pdf`);

      this.setState({ isClientSidePDF: false, modalLoader: false });
    } catch (error) {
      console.error("Error fetching PDF:", error);
      // clearInterval(timer);
      this.setState({
        isClientSidePDF: false,
        modalLoader: false,
        errorPopup: true,
        errormessage: message.CacheErrorTextPdf,
        isErrorHeader: false,
        isRedirect: false,
        isPdfClick: false,
      });
    }
  };

  toggleOnDemand = () => {
    this.setState((prevState) => ({
      modalOnDemand: !prevState.modalOnDemand,
    }));
  };

  componentWillUnmount() {
    setTimeout(() => {
      if (document.getElementById("optionDisplay")) {
        document
          .getElementById("optionDisplay")
          .setAttribute("style", "height: auto;");
      }

      if (document.getElementsByClassName("container-verf")[0]) {
        document.getElementsByClassName("container-verf")[0].style.marginTop =
          "50px";
      }
    }, 500);
  }

  handleRecommendationPreferenceRequest = (providerName, orgId) => {
    let payload = {
      providerName,
      orgId,
    };

    fetch(`${Constdata.SET_VM_RECOMMENDATION_PREFERENCES}`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.success === true) {
          this.setState({
            economicalPerfRatio: responseJson.data.economicalPerfRatio,
            enhancedCostRatio: responseJson.data.enhancedCostRatio,
          });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
        });
      });
  };

  openSvgInNewTab = (rf_goal_plot) => {
    const svg = rf_goal_plot;
    if (!svg) return;

    const blob = new Blob([svg], {
      type: "image/svg+xml",
    });

    const url = URL.createObjectURL(blob);

    window.open(url, "_blank", "noopener,noreferrer");
  };

  hasRfGoalPlot = (vm) =>
    vm?.some(
      (item) =>
        item.rf_goal_plot !== undefined &&
        item.rf_goal_plot !== null &&
        item.recommendationChoiceNum === 0
    );

  render() {
    const { analysisStatus } = this.state;
    let formatted_date = getStringDate(analysisStatus.status_change_datetime);
    let forValidation =
      this.state.resultData !== undefined &&
      this.state.resultData.validationData !== null &&
      this.state.resultData.validationData !== undefined;
    let bvmStatus = this.state.resultData.bvmState;
    let bvmStatusResChanged = this.state.resultData.bvmState;
    let hostOnly =
      this.state.resultData !== undefined &&
      this.state.resultData.aggressive !== undefined &&
      ProviderUtils.hostOnly(
        this.state.providerName,
        this.state.resultData.aggressive.metricsPlatform
      );
    if (
      forValidation === true &&
      (bvmStatus === "VALIDATED" ||
        bvmStatus === "CUSTOM-SIZED" ||
        bvmStatus === "OPTIMALLY SIZED" ||
        bvmStatus === "OPTIMIZING")
    ) {
      bvmStatus = "VALIDATED";
    }
    let isResizingDone =
      (this.state.resultData.aggressive !== undefined &&
        this.state.resultData.aggressive.isRecommendationSelected === true) ||
      (this.state.resultData.balanced !== undefined &&
        this.state.resultData.balanced.isRecommendationSelected) === true ||
      (this.state.resultData.conservative !== undefined &&
        this.state.resultData.conservative.isRecommendationSelected === true);

    let aggValidatedResized =
      forValidation &&
      this.state.resultData !== undefined &&
      this.state.resultData.validationData.perfType === "Aggressive" &&
      this.state.resultData.aggressive.isRecommendationSelected === true;
    let balValidatedResized =
      forValidation &&
      this.state.resultData !== undefined &&
      this.state.resultData.validationData.perfType === "Balanced" &&
      this.state.resultData.balanced.isRecommendationSelected === true;
    let conValidatedResized =
      forValidation &&
      this.state.resultData !== undefined &&
      this.state.resultData.validationData.perfType === "Conservative" &&
      this.state.resultData.conservative.isRecommendationSelected === true;
    let resizedObjective =
      this.state.resultData.aggressive !== undefined &&
      this.state.resultData.aggressive.isRecommendationSelected === true
        ? "Economical "
        : this.state.resultData.balanced !== undefined &&
          this.state.resultData.balanced.isRecommendationSelected === true
        ? "Balanced "
        : this.state.resultData.conservative !== undefined &&
          this.state.resultData.conservative.isRecommendationSelected === true
        ? "Enhanced "
        : " ";
    let resizingHeading = "Resizing per Selected Recommendation";
    if (
      aggValidatedResized === true ||
      balValidatedResized === true ||
      conValidatedResized === true
    ) {
      resizingHeading = "Resizing of Validated Recommendation";
    }
    let br = <br />;

    return (
      <div>
        <Header
          processLogut={this.processLogout}
          registerListners={this.props.registerListners}
          providerName={this.state.providerName}
          datetime={this.state.currentDateTime}
          loggedInUser={this.state.loggedInUser}
        />

        <div
          className="container-verf container-verf-padding"
          role="main"
          style={{ marginTop: "50px" }}
        >
          <div className="container1 boxShadow">
            {this.state.resultData.isResourceChanged !== undefined &&
            this.state.resultData.isResourceChanged === true ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227" }}>
                    {" "}
                    {bvmStatusResChanged === "VALIDATED" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            message.VMResourceChngedFlagInfoTextSummaryValidated +
                            "<br/>" +
                            this.state.resultData.resourceChangeDetails,
                        }}
                      />
                    ) : bvmStatusResChanged === "OPTIMIZING" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            message.VMResourceCHangeFlagInfoTextSummaryOptimizing +
                            "<br/>" +
                            this.state.resultData.resourceChangeDetails,
                        }}
                      />
                    ) : bvmStatusResChanged === "OPTIMALLY SIZED" ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            message.VMResourceCHangeFlagInfoTextSummaryOptimized +
                            "<br/>" +
                            this.state.resultData.resourceChangeDetails,
                        }}
                      />
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html:
                            message.VMResourceChngedFlagInfoTextSummaryAnalyzed +
                            "<br/>" +
                            this.state.resultData.resourceChangeDetails,
                        }}
                      />
                    )}
                  </div>
                </div>
              </Row>
            ) : null}
            {this.state.resultData.isSameMetricPlatform === false ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227" }}>
                    {" "}
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          this.state.resultData.metricPlatformChangeDetails,
                      }}
                    />
                  </div>
                </div>
              </Row>
            ) : null}
            {this.state.resultData.priceChangeMsg !== null ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227" }}>
                    <div>{this.state.resultData.priceChangeMsg}</div>
                  </div>
                </div>
              </Row>
            ) : null}

            {this.state.resultData &&
            this.state.resultData.isSameResizePreference === false ? (
              <Row>
                <div
                  className="InfoDiv"
                  style={{
                    backgroundColor: "#ffffff",
                    marginBottom: "5px",
                    borderRadius: "7px",
                  }}
                >
                  <div style={{ color: "#e32227" }}>
                    <div>{message.AnalyzedPreferenceMsg}</div>
                  </div>
                </div>
              </Row>
            ) : null}

            {/*<Row>
                        {(this.state.resultData.metricDataAvalability !== undefined && this.state.resultData.metricDataAvalability !== null && this.state.resultData.metricDataAvalability.trim() !== "") ?
                        <div className="InfoDiv" style={{backgroundColor:"#ffffff", marginBottom:"5px" , borderRadius:"7px"}}>
                            <div style={{color:"#e32227", width:"80%"}}><div>Note : {this.state.resultData.metricDataAvalability}</div></div>
                        </div> : null }
                    </Row>*/}
            <Row className="pageBgHeader" style={{ height: "unset" }}>
              <Col
                sm="12"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  id="spaceFiller"
                  className="d-none d-md-block"
                  style={{ width: "70px" }}
                ></div>
                <div
                  style={{
                    // width: "80%",
                    textAlign: "center",
                    fontSize: window.innerWidth < 767 ? "14px" : "18px",
                    fontWeight: "500",
                    padding: window.innerWidth < 767 ? "5px 0px" : "",
                  }}
                >
                  {this.state.resultData.vminfo}
                  <div
                    style={{
                      fontSize: window.innerWidth < 767 ? "12px" : "18px",
                      paddingTop: window.innerWidth < 767 ? "5px" : "",
                    }}
                  >
                    {this.state.resultData &&
                    this.state.resultData.analysisDatetimestamp
                      ? `Analyzed: ${getStringDate(
                          this.state.resultData.analysisDatetimestamp
                        )}`
                      : null}

                    {this.state.resultData &&
                    (this.state.resultData.bvmState === "ANALYZED" ||
                      this.state.resultData.bvmState === "VERIFIED" ||
                      this.state.resultData.bvmState === "OPTIMIZED")
                      ? this.state.resultData.metricDataDurationUsed !== null
                        ? `, ${this.state.resultData.metricDataDurationUsed}`
                        : null
                      : null}
                  </div>
                </div>
                <div
                  style={{
                    // width: "10%",
                    display: "flex",
                    justifyContent: "flex-end",
                    minWidth: window.innerWidth < 767 ? "35px" : "",
                  }}
                >
                  <ButtonGroup
                    style={{
                      height: window.innerWidth < 767 ? "unset" : "36px",
                      display:
                        window.innerWidth < 767 ? "block" : "inline-flex",
                    }}
                  >
                    <div
                      outline
                      onClick={() => {
                        this.showOverview("1", "");
                      }}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    >
                      <img
                        style={{ margin: "5px" }}
                        src={require("../../images/Show_derails1.svg")}
                        title="Show Details"
                      />
                    </div>
                    <div
                      outline
                      onClick={this.handleClientSidePDF}
                      style={{ marginRight: "5px", cursor: "pointer" }}
                    >
                      <img
                        style={{ margin: "5px" }}
                        src={require("../../images/PDF_Icon1.svg")}
                        title="Save as PDF Report"
                      />
                    </div>
                    <div
                      outline
                      onClick={this.handleClose}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={require("../../images/Close_Icon1.svg")}
                        title="Close"
                      />
                    </div>
                  </ButtonGroup>
                </div>
              </Col>
            </Row>

            {/* {this.state.resultData?.utilPlotImg ||
            this.state.resultData?.healthPlotImg ? (
              <>
                <div className="Sub-Heading pageBgWhite" id="analysisSummary">
                  Current and Expected Utilization and Health Plots
                </div>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                  }}
                >
                  {this.state.resultData?.utilPlotImg && (
                    <Col style={{ padding: "10px" }}>
                      <img
                        style={{ cursor: "pointer" }}
                        src={`data:image/jpeg;base64,${this.state.resultData?.utilPlotImg}`}
                        title="Utilization Plot"
                        onClick={() => {
                          const newTab = window.open();
                          newTab.document.write(
                            `<html>
                                  <head>
                                    <title>Utilization Plot</title>
                                    <style>
                                      body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #111; }
                                      img { max-width: 100%; max-height: 100%; cursor: zoom-in; transition: transform 0.25s ease; }
                                      img.zoomed { transform: scale(2); cursor: zoom-out; }
                                    </style>
                                  </head>
                                  <body>
                                    <img id="zoomImg" src="data:image/jpeg;base64,${this.state.resultData?.utilPlotImg}" />
                                    <script>
                                      const img = document.getElementById("zoomImg");
                                      img.addEventListener("click", () => {
                                        img.classList.toggle("zoomed");
                                      });
                                    </script>
                                  </body>
                                </html>`
                          );
                          newTab.document.title = "Utilization Plot";
                        }}
                      />
                    </Col>
                  )}
                  {this.state.resultData?.healthPlotImg && (
                    <Col style={{ padding: "10px" }}>
                      <img
                        style={{ cursor: "pointer" }}
                        src={`data:image/jpeg;base64,${this.state.resultData?.healthPlotImg}`}
                        title="Health Plot"
                        onClick={() => {
                          const newTab = window.open();
                          newTab.document.write(
                            `<html>
                                  <head>
                                    <title>Health Plot</title>
                                    <style>
                                      body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #111; }
                                      img { max-width: 100%; max-height: 100%; cursor: zoom-in; transition: transform 0.25s ease; }
                                      img.zoomed { transform: scale(2); cursor: zoom-out; }
                                    </style>
                                  </head>
                                  <body>
                                    <img id="zoomImg" src="data:image/jpeg;base64,${this.state.resultData?.healthPlotImg}" />
                                    <script>
                                      const img = document.getElementById("zoomImg");
                                      img.addEventListener("click", () => {
                                        img.classList.toggle("zoomed");
                                      });
                                    </script>
                                  </body>
                                </html>`
                          );
                          newTab.document.title = "Health Plot";
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </>
            ) : null} */}
            <div>
              <div
                class="sum-header"
                id="analysis"
                style={{ marginTop: "0px" }}
              >
                <div class="mod-tab">
                  <h4>
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.showOverview("1", "1");
                      }}
                      style={{ fontSize: "24px" }}
                    >
                      Economical
                      <span style={{ fontSize: "22px" }}>
                        (<span style={{ fontStyle: "italic" }}>P90</span>)
                      </span>
                    </a>
                  </h4>
                  <span className="objectiveTagLine">
                    <i>Cost Reducing</i>
                  </span>
                  <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                    {this.state.economicalPerfRatio === 0
                      ? `Lowest Cost regardless of Performance`
                      : `Lower Cost without going below ${this.state.economicalPerfRatio} x Current Performance`}
                  </div>
                </div>
                <div class="mod-tab" id="modTwo">
                  <b>
                    <h4>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("2", "1");
                        }}
                        style={{ fontSize: "24px" }}
                      >
                        Balanced
                        <span style={{ fontSize: "22px" }}>
                          (<span style={{ fontStyle: "italic" }}>P95</span>)
                        </span>
                      </a>
                    </h4>
                  </b>
                  <span className="objectiveTagLine">
                    <i>Cost Reducing and Performance Improving</i>
                  </span>
                  <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                    Lower Cost for Same Performance
                  </div>
                </div>
                <div class="mod-tab">
                  <b>
                    <h4>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("3", "1");
                        }}
                        style={{ fontSize: "24px" }}
                      >
                        Enhanced
                        <span style={{ fontSize: "22px" }}>
                          (<span style={{ fontStyle: "italic" }}>P99.5</span>)
                        </span>
                      </a>
                    </h4>
                  </b>
                  <span className="objectiveTagLine">
                    <i>Performance Improving</i>
                  </span>
                  <div style={{ fontWeight: "400", paddingTop: "3px" }}>
                    {this.state.enhancedCostRatio === 999999
                      ? `Highest Performance regardless of Cost`
                      : `Better Performance without exceeding ${this.state.enhancedCostRatio} x Current Cost`}
                  </div>
                </div>
              </div>
              <div class="Sub-legend">
                <Row>
                  <Col id="healthcolor">
                    <label>
                      <b>Legend</b>
                    </label>
                    <div className="legendLable">
                      <div className="legendclass Good">Good</div>
                      <div className="legendclass Fair">Fair</div>
                      <div className="legendclass Poor">Poor</div>
                    </div>
                  </Col>
                </Row>
              </div>
              <div class="Sub-Heading pageBgWhite">Rightsizing Analysis</div>
              <div class="sum-cont">
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("1", "1");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    {this.state.aggIconData[0] !== undefined &&
                    this.state.aggIconData[0].gpu !== undefined &&
                    this.state.aggIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.aggIconData[0].gpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.aggIconData[0].gpumemory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].cpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].memory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].network}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].disks}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
                <div class="sum-item" id="modTwo">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("2", "7");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    {this.state.balIconData[0] !== undefined &&
                    this.state.balIconData[0].gpu !== undefined &&
                    this.state.balIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.balIconData[0].gpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.balIconData[0].gpumemory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      {" "}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].cpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].memory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].network}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].disks}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("3", "13");
                        }}
                      >
                        Show Details
                      </a>
                    </div>{" "}
                    {this.state.healthyIconData[0] !== undefined &&
                    this.state.healthyIconData[0].gpu !== undefined &&
                    this.state.healthyIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.healthyIconData[0].gpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.healthyIconData[0].gpumemory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].cpu}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].memory}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].network}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].disks}
                              isResize={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
              </div>
              <div class="Sub-Heading pageBgWhite">
                Rightsizing Recommendations
              </div>
              <div class="sum-cont">
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("1", "2");
                        }}
                      >
                        Show Details
                      </a>
                    </div>{" "}
                    {this.state.aggIconData[0] !== undefined &&
                    this.state.aggIconData[0].gpu !== undefined &&
                    this.state.aggIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.aggIconData[0].gpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>

                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.aggIconData[0].gpumemory}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].cpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].memory}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].network}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.aggIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.aggIconData[0].disks}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
                <div class="sum-item" id="modTwo">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("2", "8");
                        }}
                      >
                        Show Details
                      </a>
                    </div>{" "}
                    {this.state.balIconData[0] !== undefined &&
                    this.state.balIconData[0].gpu !== undefined &&
                    this.state.balIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.balIconData[0].gpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.balIconData[0].gpumemory}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.balIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.balIconData[0].disks}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("3", "14");
                        }}
                      >
                        Show Details
                      </a>
                    </div>{" "}
                    {this.state.healthyIconData[0] !== undefined &&
                    this.state.healthyIconData[0].gpu !== undefined &&
                    this.state.healthyIconData[0].gpu.length > 0 ? (
                      <>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.healthyIconData[0].gpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className="maindiv-summary">
                            <ColorComponent
                              data={this.state.healthyIconData[0].gpumemory}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          </div>
                        </Row>
                      </>
                    ) : null}
                    <>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.healthyIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.healthyIconData[0].disks}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                              type="recommendation"
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </>
                  </div>
                </div>
              </div>
              {this.state.resultData &&
              this.state.resultData.gaiValidationData ? (
                <div className="Sub-Heading pageBgWhite">
                  Optimization GAI Recommendations
                </div>
              ) : null}
              <div className="sum-cont">
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Aggressive" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("1", "19");
                          }}
                        >
                          Show Details
                        </a>
                      </div>{" "}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isLine={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].disks}
                              isResize={true}
                              isLine={false}
                              showInfo={false}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </div>
                  ) : null}
                </div>
                <div className="sum-item" id="modTwo">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Balanced" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("2", "21");
                          }}
                        >
                          Show Details
                        </a>
                      </div>{" "}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].disks}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Conservative" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("3", "23");
                          }}
                        >
                          Show Details
                        </a>
                      </div>{" "}
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].cpu}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].memory}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              hostOnly={hostOnly}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].network}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                      <Row>
                        <div className="maindiv-summary">
                          {this.state.gaiIconData[0] !== undefined ? (
                            <ColorComponent
                              data={this.state.gaiIconData[0].disks}
                              isResize={true}
                              isAsp={this.state.isAsp}
                              showCostPerfMarker={true}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </Row>
                    </div>
                  ) : null}
                </div>
              </div>

              {/* <div className="Sub-Heading pageBgWhite" id="analysisSummary">
                Recommendation Actions
              </div>

              <div class="sum-cont">
                <div class="sum-item">
                  <div class="sum-inner-item">
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("1", "2");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                      <ul>
                        {this.state.resultData.aggressive?.recommendationActions.map(
                          (action, index) => (
                            <React.Fragment key={index}>
                              <li key={index}>{action}</li>
                            </React.Fragment>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("2", "8");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                      <ul>
                        {this.state.resultData.balanced?.recommendationActions.map(
                          (action, index) => (
                            <React.Fragment key={index}>
                              <li key={index}>{action}</li>
                            </React.Fragment>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("3", "14");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                      <ul>
                        {this.state.resultData.conservative?.recommendationActions.map(
                          (action, index) => (
                            <React.Fragment key={index}>
                              <li key={index}>{action}</li>
                            </React.Fragment>
                          )
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              </div> */}

              <div class="Sub-Heading pageBgWhite" id="analysisSummary">
                Benefits and Drawbacks
              </div>
              <div class="sum-cont">
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("1", "2", "1-2-Benefits");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    {this.state.resultData.aggressive?.summaryList &&
                      this.state.resultData.aggressive.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                    {this.state.resultData.aggressive?.summaryList &&
                      this.state.resultData.aggressive.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("2", "8", "2-2-Benefits");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    {this.state.resultData.balanced?.summaryList &&
                      this.state.resultData.balanced.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                    {this.state.resultData.balanced?.summaryList &&
                      this.state.resultData.balanced.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {" "}
                    <div id="ShowDetails">
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          this.showOverview("3", "14", "3-2-Benefits");
                        }}
                      >
                        Show Details
                      </a>
                    </div>
                    {this.state.resultData.conservative?.summaryList &&
                      this.state.resultData.conservative.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.costSummaryText !== undefined &&
                            filteredItem.costSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.costSummaryDescription}
                                    title={filteredItem.costSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                    {this.state.resultData.conservative?.summaryList &&
                      this.state.resultData.conservative.summaryList
                        .filter((item) => item.recommendationChoiceNum === 0)
                        .map(
                          (filteredItem, index) =>
                            filteredItem.perfSummaryText !== undefined &&
                            filteredItem.perfSummaryText !== null && (
                              <Row>
                                <div className="maindiv-text-summary maindiv-text-summary-grad">
                                  <ResingBenefitTextComponent
                                    data={filteredItem.perfSummaryDescription}
                                    title={filteredItem.perfSummaryText}
                                  />
                                </div>
                              </Row>
                            )
                        )}
                  </div>
                </div>
              </div>

              {this.state.resultData &&
              this.state.resultData.gaiValidationData ? (
                <div className="Sub-Heading pageBgWhite" id="analysisSummary">
                  Expected Benefits & Drawbacks of GAI Recommendations
                </div>
              ) : null}

              <div className="sum-cont">
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Aggressive" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("1", "20");
                          }}
                        >
                          Show Details
                        </a>
                      </div>
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            {this.state.resultData.gaiValidationData !==
                            undefined ? (
                              <ResingBenefitTextComponent
                                data={
                                  this.state.resultData.gaiValidationData
                                    .summary.costSummaryDescription
                                }
                                title={
                                  this.state.resultData.gaiValidationData
                                    .summary.costSummaryText
                                }
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryDescription
                              }
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryText
                              }
                            />
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Balanced" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("2", "22");
                          }}
                        >
                          Show Details
                        </a>
                      </div>
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryText
                              }
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryDescription
                              }
                            />
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryDescription
                              }
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryText
                              }
                            />
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : null}
                </div>
                <div className="sum-item">
                  {this.state.resultData &&
                  this.state.resultData.gaiValidationData &&
                  this.state.resultData.gaiValidationData.validationPerfType ===
                    "Conservative" ? (
                    <div className="sum-inner-item">
                      {" "}
                      <div id="ShowDetails">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            this.showOverview("3", "24");
                          }}
                        >
                          Show Details
                        </a>
                      </div>
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .costSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryText
                              }
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .costSummaryDescription
                              }
                            />
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                      {this.state.resultData.gaiValidationData !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== undefined &&
                      this.state.resultData.gaiValidationData.summary
                        .perfSummaryText !== null ? (
                        <Row>
                          <div className="maindiv-text-summary maindiv-text-summary-grad">
                            <ResingBenefitTextComponent
                              data={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryDescription
                              }
                              title={
                                this.state.resultData.gaiValidationData.summary
                                  .perfSummaryText
                              }
                            />
                          </div>
                        </Row>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* {["aggressive", "balanced", "conservative"].some((type) =>
                this.state.resultData?.[type]?.vm?.some(
                  (item) =>
                    item.recommendationChoiceNum === 0 &&
                    item.gaiInsightSummary !== undefined &&
                    item.gaiInsightSummary !== null
                )
              ) ? (
                <div className="Sub-Heading pageBgWhite" id="analysisSummary">
                  AI Insights
                </div>
              ) : null}

              <div class="sum-cont">
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {this.state.resultData.aggressive?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <React.Fragment key={index}>
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("1", "25");
                              }}
                            >
                              Show Details
                            </a>
                          </div>

                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                              {filteredItem.gaiInsightSummary}
                            </div>
                          </Row>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {this.state.resultData.balanced?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <React.Fragment key={index}>
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("1", "25");
                              }}
                            >
                              Show Details
                            </a>
                          </div>

                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                              {filteredItem.gaiInsightSummary}
                            </div>
                          </Row>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
                <div class="sum-item">
                  <div class="sum-inner-item">
                    {this.state.resultData.conservative?.vm
                      ?.filter(
                        (item) =>
                          item.recommendationChoiceNum === 0 &&
                          item.gaiInsightSummary !== undefined &&
                          item.gaiInsightSummary !== null
                      )
                      .map((filteredItem, index) => (
                        <React.Fragment key={index}>
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("1", "25");
                              }}
                            >
                              Show Details
                            </a>
                          </div>

                          <Row>
                            <div className="maindiv-text-summary maindiv-text-summary-grad p-3 px-4">
                              {filteredItem.gaiInsightSummary}
                            </div>
                          </Row>
                        </React.Fragment>
                      ))}
                  </div>
                </div>
              </div> */}

              {(this.hasRfGoalPlot(this.state.resultData.aggressive?.vm) ||
                this.hasRfGoalPlot(this.state.resultData.balanced?.vm) ||
                this.hasRfGoalPlot(this.state.resultData.conservative?.vm)) && (
                <>
                  <hr style={{ width: "98%" }} />
                  <div className="Sub-Heading pageBgWhite">Insights</div>
                  <div class="sum-cont">
                    <div class="sum-item">
                      <div class="sum-inner-item">
                        <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("1", "2", "1-2-insights");
                            }}
                          >
                            Show Details
                          </a>
                        </div>
                        {this.state.resultData.aggressive?.vm
                          ?.filter(
                            (item) =>
                              item.rf_goal_plot !== undefined &&
                              item.rf_goal_plot !== null &&
                              item.recommendationChoiceNum === 0
                          )
                          .map((filteredItem, index) => (
                            <React.Fragment key={index}>
                              <div className="svg-wrapper">
                                <div
                                  className="svg-view-icon"
                                  title="Open image in new tab"
                                  onClick={() =>
                                    this.openSvgInNewTab(
                                      filteredItem?.rf_goal_plot
                                    )
                                  }
                                >
                                  <FaSearchPlus size={24} />
                                </div>

                                <div
                                  className="svg-container"
                                  dangerouslySetInnerHTML={{
                                    __html: filteredItem?.rf_goal_plot,
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          ))}
                      </div>
                    </div>
                    <div class="sum-item" id="modTwo">
                      <div class="sum-inner-item">
                      <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("2", "8", "2-2-insights");
                            }}
                          >
                            Show Details
                          </a>
                        </div>
                        {this.state.resultData.balanced?.vm
                          ?.filter(
                            (item) =>
                              item.rf_goal_plot !== undefined &&
                              item.rf_goal_plot !== null &&
                              item.recommendationChoiceNum === 0
                          )
                          .map((filteredItem, index) => (
                            <React.Fragment key={index}>
                              <div className="svg-wrapper">
                                <div
                                  className="svg-view-icon"
                                  title="Open image in new tab"
                                  onClick={() =>
                                    this.openSvgInNewTab(
                                      filteredItem?.rf_goal_plot
                                    )
                                  }
                                >
                                  <FaSearchPlus size={24} />
                                </div>

                                <div
                                  className="svg-container"
                                  dangerouslySetInnerHTML={{
                                    __html: filteredItem?.rf_goal_plot,
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          ))}
                      </div>
                    </div>
                    <div class="sum-item">
                      <div class="sum-inner-item">
                      <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("3", "14", "3-2-insights");
                            }}
                          >
                            Show Details
                          </a>
                        </div>
                        {this.state.resultData.conservative?.vm
                          ?.filter(
                            (item) =>
                              item.rf_goal_plot !== undefined &&
                              item.rf_goal_plot !== null &&
                              item.recommendationChoiceNum === 0
                          )
                          .map((filteredItem, index) => (
                            <React.Fragment key={index}>
                              <div className="svg-wrapper">
                                <div
                                  className="svg-view-icon"
                                  title="Open image in new tab"
                                  onClick={() =>
                                    this.openSvgInNewTab(
                                      filteredItem?.rf_goal_plot
                                    )
                                  }
                                >
                                  <FaSearchPlus size={24} />
                                </div>

                                <div
                                  className="svg-container"
                                  dangerouslySetInnerHTML={{
                                    __html: filteredItem?.rf_goal_plot,
                                  }}
                                />
                              </div>
                            </React.Fragment>
                          ))}
                      </div>
                    </div>
                  </div>
                </>
              )}

              {this.state.resultData.validationData !== null &&
              this.state.resultData.validationData !== undefined ? (
                <div id="validation">
                  <div class="Sub-Heading pageBgWhite">
                    Recommendation Validation
                  </div>
                  <div class="sum-cont">
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Aggressive"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Aggressive" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("1", "4");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          <Row>
                            <ValidationSummary
                              data={this.state.resultData.validationData}
                              bvmState={this.state.resultData.bvmState}
                            />
                          </Row>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Balanced"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Balanced" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("2", "10");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          <Row>
                            <ValidationSummary
                              data={this.state.resultData.validationData}
                              bvmState={this.state.resultData.bvmState}
                            />
                          </Row>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Conservative"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Conservative" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("3", "16");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          <Row>
                            <ValidationSummary
                              data={this.state.resultData.validationData}
                              bvmState={this.state.resultData.bvmState}
                            />
                          </Row>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ) : null}

              {this.state.resultData.validationData !== null &&
              this.state.resultData.validationData !== undefined &&
              this.state.resultData.validationData.validationVM !== null ? (
                <div>
                  <div class="Sub-Heading pageBgWhite" id="valsummary">
                    Validated Benefits & Drawbacks of Recommendation
                  </div>
                  <div class="sum-cont">
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Aggressive"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Aggressive" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("1", "5");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          {this.state.resultData.aggressive !== undefined &&
                          this.state.resultData.aggressive.validation_summary
                            .costSummaryText !== undefined &&
                          this.state.resultData.aggressive.validation_summary
                            .costSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  title={
                                    this.state.resultData.aggressive
                                      .validation_summary.costSummaryText
                                  }
                                  data={
                                    this.state.resultData.aggressive
                                      .validation_summary.costSummaryDescription
                                  }
                                  affectString={
                                    this.state.resultData.aggressive
                                      .validation_summary.perfAffected
                                  }
                                  valResult={
                                    this.state.resultData.aggressive
                                      .validation_summary.validation_cost_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Aggressive" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}

                          {this.state.resultData.aggressive !== undefined &&
                          this.state.resultData.aggressive.validation_summary
                            .perfSummaryText !== undefined &&
                          this.state.resultData.aggressive.validation_summary
                            .perfSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  data={
                                    this.state.resultData.aggressive
                                      .validation_summary.perfSummaryDescription
                                  }
                                  title={
                                    this.state.resultData.aggressive
                                      .validation_summary.perfSummaryText
                                  }
                                  affectString={
                                    this.state.resultData.aggressive.summary
                                      .increasedCost
                                  }
                                  valResult={
                                    this.state.resultData.aggressive
                                      .validation_summary.validation_perf_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Aggressive" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Balanced"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Balanced" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("2", "11");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          {this.state.resultData.balanced !== undefined &&
                          this.state.resultData.balanced.validation_summary
                            .costSummaryText !== undefined &&
                          this.state.resultData.balanced.validation_summary
                            .costSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  title={
                                    this.state.resultData.balanced
                                      .validation_summary.costSummaryText
                                  }
                                  data={
                                    this.state.resultData.balanced
                                      .validation_summary.costSummaryDescription
                                  }
                                  affectString={
                                    this.state.resultData.balanced
                                      .validation_summary.perfAffected
                                  }
                                  valResult={
                                    this.state.resultData.balanced
                                      .validation_summary.validation_cost_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Balanced" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}

                          {this.state.resultData.balanced !== undefined &&
                          this.state.resultData.balanced.validation_summary
                            .perfSummaryText !== undefined &&
                          this.state.resultData.balanced.validation_summary
                            .perfSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  data={
                                    this.state.resultData.balanced
                                      .validation_summary.perfSummaryDescription
                                  }
                                  title={
                                    this.state.resultData.balanced
                                      .validation_summary.perfSummaryText
                                  }
                                  affectString={
                                    this.state.resultData.balanced
                                      .validation_summary.increasedCost
                                  }
                                  valResult={
                                    this.state.resultData.balanced
                                      .validation_summary.validation_perf_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Balanced" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      class="sum-item"
                      id={
                        this.state.resultData.validationData.perfType ===
                        "Conservative"
                          ? "modTwo"
                          : ""
                      }
                    >
                      {this.state.resultData.validationData.perfType ===
                      "Conservative" ? (
                        <div class="sum-inner-item">
                          <div id="ShowDetails">
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                this.showOverview("3", "17");
                              }}
                            >
                              Show Details
                            </a>
                          </div>
                          {this.state.resultData.conservative !== undefined &&
                          this.state.resultData.conservative.validation_summary
                            .costSummaryText !== undefined &&
                          this.state.resultData.conservative.validation_summary
                            .costSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  title={
                                    this.state.resultData.conservative
                                      .validation_summary.costSummaryText
                                  }
                                  data={
                                    this.state.resultData.conservative
                                      .validation_summary.costSummaryDescription
                                  }
                                  affectString={
                                    this.state.resultData.conservative
                                      .validation_summary.perfAffected
                                  }
                                  valResult={
                                    this.state.resultData.conservative
                                      .validation_summary.validation_cost_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Conservative" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}

                          {this.state.resultData.conservative !== undefined &&
                          this.state.resultData.conservative.validation_summary
                            .perfSummaryText !== undefined &&
                          this.state.resultData.conservative.validation_summary
                            .perfSummaryText !== null ? (
                            <Row>
                              <div className="maindiv-text-summary maindiv-text-summary-grad">
                                <ResingBenefitTextComponent
                                  data={
                                    this.state.resultData.conservative
                                      .validation_summary.perfSummaryDescription
                                  }
                                  title={
                                    this.state.resultData.conservative
                                      .validation_summary.perfSummaryText
                                  }
                                  affectString={
                                    this.state.resultData.conservative
                                      .validation_summary.increasedCost
                                  }
                                  valResult={
                                    this.state.resultData.conservative
                                      .validation_summary.validation_perf_result
                                  }
                                  renderIcon={
                                    this.state.resultData.validationData
                                      .perfType === "Conservative" &&
                                    this.state.resultData.bvmState !==
                                      "VALIDATING"
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            </Row>
                          ) : null}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}

              {this.state.resultData.aggressive !== undefined ? (
                this.state.resultData.aggressive.isRecommendationSelected ===
                true ? (
                  <div class="Sub-Heading pageBgWhite" id="resize">
                    {resizingHeading}
                  </div>
                ) : this.state.resultData.balanced !== undefined ? (
                  this.state.resultData.balanced.isRecommendationSelected ===
                  true ? (
                    <div class="Sub-Heading pageBgWhite" id="resize">
                      {resizingHeading}
                    </div>
                  ) : this.state.resultData.conservative !== undefined ? (
                    this.state.resultData.conservative
                      .isRecommendationSelected === true ? (
                      <div class="Sub-Heading pageBgWhite" id="resize">
                        {resizingHeading}
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )
              ) : null}
              <div
                class="sum-cont"
                style={{ borderRadius: "0px 0px 10px 10px" }}
              >
                <div
                  class="sum-item"
                  id={
                    this.state.resultData.aggressive !== undefined
                      ? this.state.resultData.aggressive
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.aggressive !== undefined ? (
                    this.state.resultData.aggressive
                      .isRecommendationSelected === true ? (
                      <div class="sum-inner-item">
                        {" "}
                        <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("1", "6");
                            }}
                          >
                            Show Details
                          </a>
                        </div>
                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.aggressive}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>

                <div
                  class="sum-item"
                  id={
                    this.state.resultData.balanced !== undefined
                      ? this.state.resultData.balanced
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.balanced !== undefined ? (
                    this.state.resultData.balanced.isRecommendationSelected ===
                    true ? (
                      <div class="sum-inner-item">
                        {" "}
                        <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("2", "12");
                            }}
                          >
                            Show Details
                          </a>
                        </div>
                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.balanced}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>

                <div
                  class="sum-item"
                  id={
                    this.state.resultData.conservative !== undefined
                      ? this.state.resultData.conservative
                          .isRecommendationSelected === true
                        ? "modTwo"
                        : ""
                      : ""
                  }
                >
                  {this.state.resultData.conservative !== undefined ? (
                    this.state.resultData.conservative
                      .isRecommendationSelected === true ? (
                      <div class="sum-inner-item">
                        <div id="ShowDetails">
                          <a
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.showOverview("3", "18");
                            }}
                          >
                            Show Details
                          </a>
                        </div>

                        <Row>
                          <SummaryStatus
                            data={this.state.resultData.conservative}
                            bvmState={this.state.resultData.bvmState}
                          />
                        </Row>
                      </div>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>

            {this.state.errorPopup === true ? (
              <SerraError
                Errordata={this.state.errormessage}
                ErrorPopup={this.state.errorPopup}
                setErrorMethod={this.setErrorPopupState}
                isError={this.state.isErrorHeader}
              ></SerraError>
            ) : (
              ""
            )}
            {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
          </div>
        </div>
        <a id="pdfid" />

        <Modal
          isOpen={this.state.modalOnDemand}
          toggle={this.toggleOnDemand}
          size="lg"
          backdrop={"static"}
        >
          <ModalHeader
            id="modalheader_list"
            cssModule={{ "modal-title": "modalHeader" }}
            toggle={this.toggleOnDemand}
          >
            <div
              className="modalCompanyName"
              dangerouslySetInnerHTML={{ __html: message.SerraLabsModalHeader }}
            />{" "}
            <div className="modalTitle">Query On Demand Metrics</div>
          </ModalHeader>
          <ModalBody>
            <OnDemandMetrics
              cancelOnDemand={this.toggleOnDemand}
              analysisStatus={this.state.analysisStatus}
            ></OnDemandMetrics>
          </ModalBody>
        </Modal>

        {this.state.isClientSidePDF && this.state.resultData && (
          <>
            <EntityTypeSummary
              companiesDetails={this.props.companyDetails}
              data={this.state.resultData}
              isMargin={true}
              isAsp={this.state.isAsp}
              entityType={this.state.entityType}
              userGmtId="IST"
              userTimeZone="Asia/Calcutta"
              analysisCnt={1}
              enhancedCostRatio={this.state.enhancedCostRatio}
              economicalPerfRatio={this.state.economicalPerfRatio}
              providerName={this.state.providerName}
            />
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
    // onClick datasource refresh state
    refreshStatus: state.dataSourcePayload.refreshStatus,
    isRefreshDSAPI: state.dataSourcePayload.isRefreshDSAPI,
    // 5 min datasource refresh state
    isRefreshing: state.datasource.isRefreshing,
    datasourceRefreshStatus: state.datasource.refreshStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDataSourceRefreshStatus: (data) =>
      dispatch(setDataSourceRefreshStatus(data)),
    startRefreshTimer: () => resetRefreshTimer(dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Summary));
